module.exports = __webpack_public_path__ + "static/media/back_panel.82d2232e.png";